/**
 * Gates the import from another assistant: the `import-from-assistant` skill
 * names it in its frontmatter, and the Settings button that starts an import
 * checks it, so the button only shows where the skill can answer it.
 */
export const ASSISTANT_IMPORT_GATE = "assistant-import";

/**
 * The first message of the thread the Settings button opens. Sent rather than
 * left in the composer, so the assistant answers at once by asking which app
 * the user is coming from. Shared so web and native start the same thread.
 */
export const IMPORT_FROM_ASSISTANT_MESSAGE =
  "I want to bring my memories, skills and routines over from another assistant.";
